import { createSlice } from "@reduxjs/toolkit";
const createScopingHeader = (name = "Customer") => ({
  customer: null,
  places: [],
  name,
});

const initialState = createScopingHeader();

export const scopingHeaderSlice = createSlice({
  name: "scopingHeader",
  initialState,
  reducers: {
    setScopingHeaderCustomer: (state, action) => {
      return {
        ...state,
        customer: action.payload.customer,
      };
    },
    setScopingHeaderPlace: (state, action) => {
      return {
        ...state,
        places: action.payload.places,
      };
    },
    handleChange: (state, action) => {
      state[action.payload.name] = action.payload.value;
    },
    clearScopingHeader: (state, action) => {
      state["name"] = "";
      state["places"] = "";
    },
  },
});
